import RiderTypes from 'store/actionTypes/rider'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  portalRole: {}
}

const rider = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case RiderTypes.GET_RIDER_LIST_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case RiderTypes.GET_RIDER_PORTAL_ROLE_SUCCESS:
      return { ...state, portalRole: payload?.portalRole }
    case RiderTypes.GET_RIDER_DETAIL_SUCCESS:
      return { ...state, current: payload?.rider }
    case RiderTypes.UPDATE_FILTER_RIDER_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default rider
